import { useRef, useState } from "react";

// Tilt + spotlight hook (safe now because it will be used in a component)
const useTiltSpotlight = () => {
  const ref = useRef(null);
  const [tiltStyle, setTiltStyle] = useState({});
  const [spot, setSpot] = useState({ x: 50, y: 50, show: false });

  const onMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const px = (e.clientX - rect.left) / rect.width;
    const py = (e.clientY - rect.top) / rect.height;

    const rotateX = (0.5 - py) * 10;
    const rotateY = (px - 0.5) * 10;

    setTiltStyle({
      transform: `perspective(900px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(0)`,
    });
    setSpot({ x: px * 100, y: py * 100, show: true });
  };

  const onLeave = () => {
    setTiltStyle({
      transform: `perspective(900px) rotateX(0deg) rotateY(0deg) translateZ(0)`,
    });
    setSpot((s) => ({ ...s, show: false }));
  };

  return { ref, tiltStyle, spot, onMove, onLeave };
};

export default useTiltSpotlight;
